import {
  styled,
  css,
  Box,
  Checkbox,
  FormControlLabel,
  Typography
} from '@mui/material'

export const FiltersCounter = styled(Box, {
  shouldForwardProp: (prop) => !['count'].includes(String(prop))
})<{ count: number }>(
  ({ count }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 24px;
    width: 24px;
    background: #f4f4f4;
    border-radius: 2px;
    font-size: 12px;
    color: ${count === 0 ? '#BABABA' : '#2C2C2C'};
  `
)

export const OptionCheckbox = styled(Checkbox)(
  ({ theme }) => css`
    color: rgba(118, 118, 118, 1);
    &.Mui-checked {
      color: ${theme.palette.primary.main};
    }
  `
)

export const LabeledCheckbox = styled(FormControlLabel)(
  () => css`
    justify-content: space-between;
    font-size: 12px;
  `
)

export const CheckboxLabel = styled(Typography)(
  () => css`
    font-size: 12px;
  `
)
